<script setup lang="ts">
// 動作検証に使えるURL例
// http://localhost:3000/send_message/insurance_product_consultation_request?request=JTdCJTIyaWQlMjIlM0ElMjI1JTIyJTJDJTIybmFtZSUyMiUzQSUyMiVFNyU4NCVBMSVFOCVBNyVBMyVFNyVCNCU4NCVFOCVCRiU5NCVFNiU4OCVCQiVFOSU4NyU5MSVFNSU5RSU4QiVFNSU4RiU4RSVFNSU4NSVBNSVFNCVCRiU5RCVFOSU5QSU5QyVFNCVCRiU5RCVFOSU5OSVCQSVFRiVCQyU4ODIwMjMlRUYlQkMlODklMjIlMkMlMjJjb21wYW55TmFtZSUyMiUzQSUyMiVFMyU4MyU4RCVFMyU4MiVBQSVFMyU4MyU5NSVFMyU4MiVBMSVFMyU4MyVCQyVFMyU4MiVCOSVFMyU4MyU4OCVFNyU5NCU5RiVFNSU5MSVCRCUyMiU3RA%3D%3D
// TODO: e2e書く
import {
  registerVariantQueryKey,
  registerVariants,
} from '@/components/templates/RegisterUserTemplate/useRegisterValiant';
import { usePostPersistedMessage } from '@/composables/microservice/cinnamon/usePostPersistedMessage';
import IconSpinner from 'theme/components/atoms/icons/IconSpinner.vue';
import { insuranceProductConsultationRequestsSchema } from 'theme/types/requestSchemas/insuranceComparison';
import { base64ToObject } from 'theme/utils/base64';
import { parse } from 'valibot';
import { CHANNEL_ID_MAP } from '~/entity/channel';

const route = useRoute();
const router = useRouter();

const { setChannelId } = useChannelId();
setChannelId(CHANNEL_ID_MAP.FOUR_HUNDRED_F_INSURANCE_COMPARISON);

const { fetch } = usePostPersistedMessage();

const { plannerId } = useInsuranceComparisonPlanner();

const requestQuery = getStringQuery(route.query.request);
if (!requestQuery) {
  throw createError({
    statusCode: 404,
  });
}

if (!import.meta.server) {
  const validatedRequest = (() => {
    try {
      const request = base64ToObject(requestQuery);

      return parse(insuranceProductConsultationRequestsSchema, request);
    } catch {
      return null;
    }
  })();
  if (!validatedRequest) {
    throw createError({
      statusCode: 400,
      message: 'リクエストが不正です',
    });
  }

  const message = `保険相談希望
---
会社名：${validatedRequest.companyName}
商品名：${validatedRequest.productName}`;

  const attachment = {
    type: 'insuranceProductConsultationRequest',
    content: {
      product_id: validatedRequest.productId,
      company_id: validatedRequest.companyId,
    },
  };

  const data = await fetch(message, [attachment]);
  if (!data) {
    throw createError({
      statusCode: 500,
    });
  }

  router.replace({
    path: `/planner/${plannerId}/matching`,
    query: {
      persisted_message_uuid: data.uuid,
      [registerVariantQueryKey]:
        registerVariants.insuranceProductConsultationRequest,
    },
  });
}
</script>

<template>
  <div :class="$style.wrapper">
    <IconSpinner />
  </div>
</template>

<style lang="scss" module>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 40vh;
}
</style>
